import * as React from 'react';
import {
  connect as adFoxConnect,
  TAdFoxBannerProps as TAdFoxBannerComponentProps,
  IAdFoxBannerOnLoadData,
} from '@cian/adfox-component';

import { withAdfoxPostViewAnalytics } from '@cian/postview-analytics-utils';
import { TBannerType } from '../../../../../types/banner';
import { OwnTemplatesContainer } from '../OwnTemplates';

const NewAdfoxBannerContainerComponent = adFoxConnect(OwnTemplatesContainer);

type TNewAdfoxBannerContainerProps = {
  bannerType: TBannerType;
  disableYan?: boolean;
} & TAdFoxBannerComponentProps;

export const NewAdfoxBannerContainer: React.FC<TNewAdfoxBannerContainerProps> = props => {
  const [hidden, setHidden] = React.useState(false);
  const { disableYan, ...sharedProps } = props;

  const handleLoad = React.useCallback(
    (data: IAdFoxBannerOnLoadData, containerId: string) => {
      const { bundleName } = data;
      const { disableYan, onLoad } = props;

      if (disableYan && bundleName === 'banner.direct') {
        setHidden(true);
      }

      if (onLoad) {
        onLoad(data, containerId);
      }
    },
    [disableYan, sharedProps.onLoad],
  );

  if (disableYan && hidden) {
    return null;
  }

  const bannerProps = {
    ...sharedProps,
    onLoad: handleLoad,
  };

  const AdfoxBannerWithPostView = withAdfoxPostViewAnalytics(NewAdfoxBannerContainerComponent, bannerProps, {
    banner: {
      place: props.bannerType,
      name: 'BuildingProgress_JK_TGB',
    },
  });

  return <AdfoxBannerWithPostView />;
};
